export enum NotificationType {
    INFO = 'info',
    SUCCESS = 'success',
    WARNING = 'warning',
    ERROR ='error',
    // CRITICAL
}

export default interface Notification {
    readonly message: string;
    readonly type: NotificationType;
}
